<!-- eslint-disable vue/no-mutating-props -->
<template>
    <v-row>
        <v-col cols="3">
            <v-select
                v-model="complaint.complaintProductionDepartmentId"
                :items="productionDepartments"
                label="Dział"
                item-value="id"
                item-text="name"
                no-data-text="Nie znaleziono działu"
                clearable
                :disabled="isReadOnly"
                :error="isFieldInvalid('complaintProductionDepartmentId')"
                :error-messages="validationMessages('complaintProductionDepartmentId')"
                @blur="triggerBlur('complaintProductionDepartmentId')"
                @change="handleProductionDepartmentChange"
            />
        </v-col>

        <v-col cols="3">
            <v-select
                v-model="complaint.productionSiteGroupId"
                :items="productionSiteGroups"
                label="Grupa stanowisk"
                item-value="id"
                item-text="name"
                no-data-text="Nie znaleziono grupy stanowisk"
                :disabled="isReadOnly || !canPickProductionSiteGroup"
                clearable
                @change="handleProductionSiteGroupChange"
            />
        </v-col>

        <v-col cols="3">
            <v-select
                v-model="complaint.productionProcessId"
                :items="productionProcesses"
                label="Proces produkcyjny"
                item-value="id"
                item-text="name"
                no-data-text="Nie znaleziono procesów produkcyjnych"
                :disabled="isReadOnly || !canPickProductionProcess"
                clearable
            />
        </v-col>

        <v-col cols="3">
            <v-select
                v-model="complaint.machineId"
                :items="machines"
                label="Maszyna"
                item-value="id"
                item-text="name"
                no-data-text="Nie znaleziono maszyn"
                :disabled="isReadOnly || !canPickMachine"
                clearable
            />
        </v-col>
    </v-row>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
export default {
    name: 'DetailsTabProductionSection',

    props: {
        complaint: {
            type: Object,
            required: true,
        },
        validation: {
            type: Object,
            default: () => ({}),
        },
        storeModuleName: {
            type: String,
            default: '',
        },
        isReadOnly: {
            type: Boolean,
        },
    },

    computed: {
        validationState() {
            const fields = [
                'complaintProductionDepartmentId',
            ]

            const provided = this.validation || {}

            return fields.reduce((acc, field) => {
                const entry = provided[field] || {}

                acc[field] = {
                    error: Boolean(entry.error),
                    messages: Array.isArray(entry.messages) ? entry.messages : [],
                }

                return acc
            }, {})
        },

        productionDepartments() {
            return this.$store.state.complaints.internalComplaints.productionDepartments
        },

        productionSiteGroups() {
            return this.$store.state.complaints.internalComplaints.productionSiteGroups
        },

        productionProcesses() {
            return this.$store.state.complaints.internalComplaints.productionProcesses
        },

        machines() {
            return this.$store.state.complaints.internalComplaints.machines
        },

        canPickProductionSiteGroup() {
            return Boolean(this.complaint?.complaintProductionDepartmentId)
        },

        canPickProductionProcess() {
            return Boolean(this.complaint?.complaintProductionDepartmentId)
        },

        canPickMachine() {
            return Boolean(this.complaint?.productionSiteGroupId)
        },
    },

    methods: {
        validationNode(field) {
            return this.validationState[field] || null
        },

        isFieldInvalid(field) {
            const node = this.validationNode(field)

            return Boolean(node && node.error)
        },

        validationMessages(field) {
            const node = this.validationNode(field)

            if (!node || !Array.isArray(node.messages)) return []

            return node.messages
        },

        triggerBlur(field) {
            this.$emit('field-blur', field)
        },

        async handleProductionDepartmentChange() {
            this.triggerBlur('complaintProductionDepartmentId')

            this.complaint.productionSiteGroupId = null
            this.complaint.productionProcessId = null
            this.complaint.machineId = null

            if (!this.complaint.complaintProductionDepartmentId) return

            await this.$store.dispatch(
                `${this.storeModuleName}/getProductionSiteGroups`,
                this.complaint.complaintProductionDepartmentId
            )

            await this.fetchProductionProcesses()
        },

        async handleProductionSiteGroupChange() {
            this.complaint.productionProcessId = null
            this.complaint.machineId = null

            await this.fetchProductionProcesses()
            await this.fetchMachines()
        },

        async fetchProductionProcesses() {
            const { complaintProductionDepartmentId, productionSiteGroupId } = this.complaint

            if (!complaintProductionDepartmentId) return

            const query = productionSiteGroupId
                ? { productionSiteGroupId }
                : { complaintProductionDepartmentId }

            await this.$store.dispatch(`${this.storeModuleName}/getProductionProcesses`, query)
        },

        async fetchMachines() {
            if (!this.complaint.productionSiteGroupId) return

            await this.$store.dispatch(`${this.storeModuleName}/getMachines`, this.complaint.productionSiteGroupId)
        },
    },
}
</script>
